<template>
    <div>
        <div :class="state == 0 ? 'no_data' : 'no_network' ">
            <img class="tips_img" :src="data[state].photoUrl" alt="">
            <p class="tips_text">{{ data[state].tipsText }}</p>
        </div>
    </div>

</template>

<script>
    export default {
        name: "error-tips",
        props: {
            state: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                data: [
                    {photoUrl: require('@/assets/empty.png'), tipsText: '表单暂无数据哦～'},
                    {photoUrl: require('@/assets/no_network.png'), tipsText: '找不到网络～'},
                ]
            }
        },
        created() {
        }
    }
</script>

<style scoped lang="less">
    .no_data {
        text-align: center;
        width: 300px;
        margin: 100px auto 486px;

        .tips_img {
            width: 184px;
            height: 118px;
            display: inline-block;
        }

        .tips_text {
            color: #666;
            font-size: 14px;
            padding-top: 15px;
        }

    }

    .no_network {
        width: 196px;
        text-align: center;
        margin: 0 auto;

        .tips_img {
            width: 196px;
            height: 118px;
            display: inline-block;
        }

        .tips_text {
            color: #666;
            font-size: 14px;
            padding-top: 28px;
        }
    }
</style>